module.exports = __webpack_public_path__ + "static/img/font.998d522.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/font.png
// module id = MvR7
// module chunks = 1